<template>
    <div class="layout-container">
        <slot></slot>
    </div>
</template>

<script setup lang="ts"></script>
